<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    작업구분-->
    <!--    <vs-row class="mt-6">-->
    <!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
    <!--        <h5>-->
    <!--          <i class="dot"></i> 작업구분-->
    <!--        </h5>-->
    <!--      </vs-col>-->
    <!--    </vs-row>-->

    <!--    <div class="gap-x-6 gap-y-4 mt-4">-->
    <!--      <span v-if="isPrint"> {{form.inspectionTitle}} </span>-->
    <!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
    <!--        <vs-checkbox-->
    <!--          class="mr-1 mb-2"-->
    <!--          :readonly="board.readonly">-->
    <!--          {{form.inspectionTitle}}-->
    <!--        </vs-checkbox>-->
    <!--      </div>-->
    <!--    </div>-->

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :isPrint="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        this.form.inspectionTitle = this.inspectionTitle;
        if (
          !this.form ||
          !this.form.inspectList ||
          this.form.inspectList.length === 0
        ) {
          this.form.inspectList = this.inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "스트레칭실",
      form: {
        inspectionTitle: "스트레칭실",
        stdInfo: {},
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: [],
      },
    };
  },
  computed: {
    inspectTable() {
      return [
        {
          id: 1,
          label: "기구 안전 상태 확인",
          is_checked: "",
        },
        {
          id: 2,
          label: "환기 적정 유무",
          is_checked: "",
        },
        {
          id: 3,
          label: "바닥 노면 미끄럼 상태",
          is_checked: "",
        },
        {
          id: 4,
          label: "보행 통로 안전 확보 상태(물건 적치여부 등)",
          is_checked: "",
        },
      ];
    },
  },
  methods: {
    updateList(list) {
      this.form.equipmentList = list;
    },
    updateListCheck(indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
